import React from "react";
import { connect } from "react-redux";
import {
  fetchFunctions,
  fetchMyRRDocs,
  selectFunction,
  updateWorkflow,
  updateFunctionNotifications,
  fetchIWPPApprovers,
  updateIWPPWorkflowApprovers,
  deleteIWPPApproverStep,
  fetchGBUs,
} from "../../reduxActions/FunctionsActions";
import { showSnackBarMessage } from "../../reduxActions/AppInfoActions";

const FunctionsContext = React.createContext({});

class FunctionsStore extends React.Component {
  state = {
    addFunctionModalOpen: false,
    workflowDialogOpen: false,
    procedureToConfirmArchive: null,
    procedureToConfirmRevision: null,
    shouldDisplayArchivedProcedures: false,
    functionNotificationDialogOpen: false,
    selectedWorkflowStep: "",
    editingIWPPApprovers: false,
    iwppApproverStepToDelete: null,
  };

  constructor(props) {
    super(props);
    this._isMounted = false;
  }

  componentDidMount() {
    this._isMounted = true;
    // Only fetch if data doesn't exist
    if (!this.props.functions.functions) {
      this.props.fetchFunctions();
    }
    if (!this.props.functions.gbus) {
      this.props.fetchGBUs();
    }
    if (!this.props.myRRDocs || !this.props.myRRDocs.length) {
      this.props.fetchMyRRDocs();
    }
  }

  componentWillUnmount() {
    this._isMounted = false;
  }

  displayAddFunction = () => {
    if (!this._isMounted) {
      return;
    }
    this.setState({ addFunctionModalOpen: true });
  };

  closeAddFunction = () => {
    if (!this._isMounted) {
      return;
    }
    this.setState({ addFunctionModalOpen: false });
  };

  displayWorkflowDialog = () => {
    if (!this._isMounted) {
      return;
    }
    this.setState({ workflowDialogOpen: true });
  };

  closeWorkflowDialog = () => {
    if (!this._isMounted) {
      return;
    }
    this.setState({ workflowDialogOpen: false });
  };

  confirmArchive = (procedureToConfirmArchive) => {
    if (!this._isMounted) {
      return;
    }
    this.setState({ procedureToConfirmArchive });
  }

  confirmRevision = (procedureToConfirmRevision) => {
    if (!this._isMounted) {
      return;
    }
    this.setState({ procedureToConfirmRevision });
  }

  displayArchivedProcedures = (shouldDisplayArchivedProcedures) => {
    if (!this._isMounted) {
      return;
    }
    this.setState({ shouldDisplayArchivedProcedures });
  }

  displayFunctionNotificationDialog = () => {
    if (!this._isMounted) {
      return;
    }
    this.setState({ functionNotificationDialogOpen: true });
  }

  closeFunctionNotificationDialog = () => {
    if (!this._isMounted) {
      return;
    }
    this.setState({ functionNotificationDialogOpen: false });
  }

  setSelectedWorkflowStep = (selectedWorkflowStep) => {
    if (!this._isMounted) {
      return;
    }
    this.setState({ selectedWorkflowStep });
  }

  editIWPPApprovers = (editingIWPPApprovers) => {
    if (!this._isMounted) {
      return;
    }
    this.setState({ editingIWPPApprovers });
  }

  confirmDeleteOfIWPPAprroverStep = (iwppApproverStepToDelete) => {
    if (!this._isMounted) {
      return;
    }
    this.setState({ iwppApproverStepToDelete });
  }

  render() {
    return (
      <FunctionsContext.Provider
        value={{
          ...this.state,
          ...this.props,
          displayAddFunction: this.displayAddFunction,
          closeAddFunction: this.closeAddFunction,
          displayWorkflowDialog: this.displayWorkflowDialog,
          closeWorkflowDialog: this.closeWorkflowDialog,
          confirmArchive: this.confirmArchive,
          confirmRevision: this.confirmRevision,
          displayArchivedProcedures: this.displayArchivedProcedures,
          displayFunctionNotificationDialog:
            this.displayFunctionNotificationDialog,
          closeFunctionNotificationDialog: this.closeFunctionNotificationDialog,
          setSelectedWorkflowStep: this.setSelectedWorkflowStep,
          editIWPPApprovers: this.editIWPPApprovers,
          confirmDeleteOfIWPPAprroverStep: this.confirmDeleteOfIWPPAprroverStep,
        }}
      >
        {this.props.children}
      </FunctionsContext.Provider>
    );
  }
}

const mapStateToProps = (state) => {
  const { functions, procedureManual, } = state;
  return {
    procedureManual,
    contentHeight: state.app.contentSize.height,
    functions: functions,
    aboutCurrentUser: state.app.aboutCurrentUser,
    myRRDocs: functions.myRRDocs
  };
};

FunctionsStore = connect(mapStateToProps, {
  fetchFunctions,
  fetchMyRRDocs,
  selectFunction,
  updateWorkflow,
  updateFunctionNotifications,
  showSnackBarMessage,
  fetchIWPPApprovers,
  updateIWPPWorkflowApprovers,
  deleteIWPPApproverStep,
  fetchGBUs,
})(FunctionsStore);

export { FunctionsStore };

export default FunctionsContext;
